import { ApiStatusState } from "./apiStatus.types";
import { GET_COUPON_DETAILS } from "../auth/auth.actionTypes";

export const initialState: ApiStatusState = {
  loading: {
    GET_COUPON_DETAILS: true,
  },
  errors: {},
  init: {},
};
